// extracted by mini-css-extract-plugin
module.exports = {"pageSize":"pageSize__eXsyz","select":"select__sXzEg"};